import React from 'react';
import { FadeIn } from './FadeIn';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'Auditoría Inicial',
    desc: 'Descarga el manual y realiza la auditoría de parálisis en 10 minutos.'
  }, {
    num: '02',
    title: 'Ejecución Inmediata',
    desc: 'Implementa el Ayuno de Dopamina y las Micro-Acciones desde la primera mañana.'
  }, {
    num: '03',
    title: 'Consolidación',
    desc: 'Sigue el calendario de 21 días para ver cómo tu energía y tu cuenta bancaria comienzan a transformarse.'
  }];
  return <section className="py-24 bg-tactical-panel border-b border-tactical-border" data-id="element-131">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl" data-id="element-132">
        <FadeIn data-id="element-133">
          <div className="text-center mb-16" data-id="element-134">
            <h2 className="text-4xl font-bold uppercase mb-4" data-id="element-135">
              Secuencia de{' '}
              <span className="text-tactical-accent" data-id="element-136">Despliegue</span>
            </h2>
            <p className="text-zinc-400 font-mono uppercase text-sm tracking-widest" data-id="element-137">
              3 Fases para la ejecución total
            </p>
          </div>
        </FadeIn>

        <div className="relative" data-id="element-138">
          {/* Desktop connecting line */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-zinc-800 z-0" data-id="element-139"></div>

          <div className="grid md:grid-cols-3 gap-8 relative z-10" data-id="element-140">
            {steps.map((step, index) => <FadeIn key={index} delay={index * 0.15} className="relative" data-id="element-141">
                <div className="bg-tactical-dark border border-tactical-border p-6 h-full flex flex-col pt-12 relative group hover:border-tactical-accent/50 transition-colors" data-id="element-142">
                  {/* Number Badge */}
                  <div className="absolute -top-6 left-6 w-12 h-12 bg-zinc-900 border-2 border-tactical-accent flex items-center justify-center font-mono font-bold text-xl text-tactical-accent group-hover:bg-tactical-accent group-hover:text-zinc-900 transition-colors" data-id="element-143">
                    {step.num}
                  </div>

                  <h3 className="font-oswald text-xl uppercase mb-3 text-zinc-100" data-id="element-144">
                    {step.title}
                  </h3>
                  <p className="text-zinc-400 text-sm leading-relaxed" data-id="element-145">
                    {step.desc}
                  </p>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}